// import React, { useState, useEffect } from 'react';
// import { ReactComponent as DownloadLic } from '../../assets/downloadLic.svg';
// import Constants from '../../services/constants';
// import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
// import API from '../../services/api';
// import { toast } from 'react-toastify';
// import { ErrorToast } from '../../pure-components/CustomToast';
// export default function License() {

//     const [monthNames, setMonthNames] = useState([{ key: "January", count: 0 }, { key: "February", count: 0 }, { key: "March", count: 0 }, { key: "April", count: 0 }, { key: "May", count: 0 },
//     { key: "June", count: 0 }, { key: "July", count: 0 }, { key: "August", count: 0 }, { key: "September", count: 0 }, { key: "October", count: 0 }, { key: "November", count: 0 }, { key: "December", count: 0 }]);

//     //, "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December" ];
//     const currentMonth = new Date().getMonth();
//     const currentyear = new Date().getFullYear();
//     const [selectedYear, setSelectedYear] = useState(currentyear);

//     let startYear = 2000;
//     let years = []
//     while (currentyear >= startYear) {
//         years.push(startYear);
//         startYear++;
//     };
//     useEffect(() => {
//         let query = [
//             {
//                 '$project': {
//                     'month': {
//                         '$month': '$createdAt'
//                     },
//                     'year': {
//                         '$year': '$createdAt'
//                     }
//                 }
//             }, {
//                 '$group': {
//                     '_id': {
//                         'month': '$month',
//                         'year': '$year'
//                     },
//                     'total': {
//                         '$sum': 1
//                     },
//                     'month': {
//                         '$first': '$month'
//                     },
//                     'year': {
//                         '$first': '$year'
//                     }
//                 }
//             }, {
//                 '$match': {
//                     'year': selectedYear
//                 }
//             }
//         ]
//         API.getLicAggregate(query).then(res => {
//             if (res.success) {
//                 let newMonthNames = [...monthNames];
//                 if (res.data.length) {
//                     res.data.forEach(item => {
//                         newMonthNames[item.month - 1].count = item.total
//                     })
//                     setMonthNames([...newMonthNames]);
//                 }
//                 else {
//                     setMonthNames([{ key: "January", count: 0 }, { key: "February", count: 0 }, { key: "March", count: 0 }, { key: "April", count: 0 }, { key: "May", count: 0 },
//                     { key: "June", count: 0 }, { key: "July", count: 0 }, { key: "August", count: 0 }, { key: "September", count: 0 }, { key: "October", count: 0 }, { key: "November", count: 0 }, { key: "December", count: 0 }])
//                 }
//                 //    setCountUser(res.data);
//             }
//         })
//     }, [selectedYear]);

//     const downloadLic = (index,liccount) => {
//         if (index <= currentMonth) {
//             if(liccount<=0)
//             {
//                 toast(({ closeToast }) => <ErrorToast message="No Track to download!"/>);
//                  }
//               else{   
//             var link = document.createElement('a');
//             link.setAttribute('download', null);
//             link.style.display = 'none';
//             document.body.appendChild(link);
//             link.setAttribute('href', `${process.env.REACT_APP_BASE_URL}api/license/OP?month=${index + 1}&year=${selectedYear}`);
//             link.click();
//             document.body.removeChild(link);

//             setTimeout(() => {
//                 var link1 = document.createElement('a');
//                 link1.setAttribute('download', null);
//                 link1.style.display = 'none';
//                 document.body.appendChild(link1);
//                 link1.setAttribute('href', `${process.env.REACT_APP_BASE_URL}api/license/CMO?month=${index + 1}&year=${selectedYear}`);
//                 link1.click();
//                 document.body.removeChild(link1);
//             }, 1000)
//         }
//         }
//     }
//     const handleChange = (event) => {
//         setSelectedYear(event.target.value);
//     };

//     return (
//         <>
//             <FormControl className="w-2/12" variant="outlined" >
//                 <InputLabel id="demo-simple-select-outlined-label">Year</InputLabel>
//                 <Select
//                     labelId="demo-simple-select-outlined-label"
//                     id="demo-simple-select-outlined"
//                     value={selectedYear}
//                     onChange={handleChange}
//                     label="Year"
//                 >
//                     {
//                         years.map(item => {
//                             return <MenuItem value={item}>{item}</MenuItem>
//                         })
//                     }


//                 </Select>
//             </FormControl>

//             <div className='flex flex-wrap'>

//                 {
//                     monthNames.map((month, index) =>
//                         <div key={index} className={`flex py-4 m-2 border border-symStrokeGrey last:border-b-0
//               ${index > currentMonth ? "cursor-not-allowed " : "cursor-pointer"}`}
//                             style={{ width: "22.5%" }}
//                             onClick={() => downloadLic(index,month.count)}
//                         // href="http://localhost:4000/api/license/OP"
//                         >
//                             <div className='self-center w-11/12 pl-2'>
//                                 <h1 className='text-2xl mr-2 text-black  font-bold' > {month.key}</h1>
//                                 <h2 className='text-xs self-center text-black font-light'>{month.count} licenses </h2>
//                             </div>
//                             <div className='w-1/12 -mt-2 mr-4'>
//                                 <DownloadLic />
//                             </div>
//                         </div>
//                     )
//                 }
//             </div>


//         </>
//     )
// }




import React, { useState, useEffect } from 'react';
import { ReactComponent as DownloadLic } from '../../assets/downloadLic.svg';
import Constants from '../../services/constants';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import API from '../../services/api';
import { toast } from 'react-toastify';
import { ErrorToast } from '../../pure-components/CustomToast';

export default function License() {
    const [monthNames, setMonthNames] = useState([
        { key: "January", count: 0 }, { key: "February", count: 0 }, { key: "March", count: 0 }, { key: "April", count: 0 }, { key: "May", count: 0 },
        { key: "June", count: 0 }, { key: "July", count: 0 }, { key: "August", count: 0 }, { key: "September", count: 0 }, { key: "October", count: 0 },
        { key: "November", count: 0 }, { key: "December", count: 0 }
    ]);

    const currentMonth = new Date().getMonth();
    const currentyear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentyear);

    let startYear = 2000;
    let years = [];
    while (currentyear >= startYear) {
        years.push(startYear);
        startYear++;
    }

    useEffect(() => {
        let query = [
            {
                '$project': {
                    'month': { '$month': '$createdAt' },
                    'year': { '$year': '$createdAt' }
                }
            }, {
                '$group': {
                    '_id': { 'month': '$month', 'year': '$year' },
                    'total': { '$sum': 1 },
                    'month': { '$first': '$month' },
                    'year': { '$first': '$year' }
                }
            }, {
                '$match': { 'year': selectedYear }
            }
        ];
        API.getLicAggregate(query).then(res => {
            if (res.success) {
                let newMonthNames = [...monthNames];
                if (res.data.length) {
                    res.data.forEach(item => {
                        newMonthNames[item.month - 1].count = item.total;
                    });
                    setMonthNames([...newMonthNames]);
                } else {
                    setMonthNames([
                        { key: "January", count: 0 }, { key: "February", count: 0 }, { key: "March", count: 0 }, { key: "April", count: 0 }, { key: "May", count: 0 },
                        { key: "June", count: 0 }, { key: "July", count: 0 }, { key: "August", count: 0 }, { key: "September", count: 0 }, { key: "October", count: 0 },
                        { key: "November", count: 0 }, { key: "December", count: 0 }
                    ]);
                }
            }
        });
    }, [selectedYear]);

    const downloadLic = (index, liccount) => {
        if (index <= currentMonth) {
            if (liccount <= 0) {
                toast(({ closeToast }) => <ErrorToast message="No Track to download!" />);
            } else {
                var link = document.createElement('a');
                link.setAttribute('download', null);
                link.style.display = 'none';
                document.body.appendChild(link);
                link.setAttribute('href', `${process.env.REACT_APP_BASE_URL}api/license/OP?month=${index + 1}&year=${selectedYear}`);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => {
                    var link1 = document.createElement('a');
                    link1.setAttribute('download', null);
                    link1.style.display = 'none';
                    document.body.appendChild(link1);
                    link1.setAttribute('href', `${process.env.REACT_APP_BASE_URL}api/license/CMO?month=${index + 1}&year=${selectedYear}`);
                    link1.click();
                    document.body.removeChild(link1);
                }, 1000);
            }
        }
    };

    const handleChange = (event) => {
        setSelectedYear(event.target.value);
    };

    return (
        <div className="bg-white shadow-lg rounded-2xl p-4 sm:p-6 m-4">
            {/* Year Selector */}
            <div className="mb-6 w-full sm:w-64">
                <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label" className="text-base font-semibold text-gray-600">
                        Year
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={selectedYear}
                        onChange={handleChange}
                        label="Year"
                        className="bg-white rounded-lg shadow-sm"
                        inputProps={{
                            className: "text-base border-gray-200 hover:border-indigo-400 focus:border-indigo-600 transition-colors duration-200",
                        }}
                    >
                        {years.map(item => (
                            <MenuItem key={item} value={item} className="text-base">
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {/* Month Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {monthNames.map((month, index) => (
                    <div
                        key={index}
                        className={`group relative overflow-hidden flex items-center p-4 border-2 rounded-xl bg-gradient-to-br from-white to-indigo-50/30 hover:from-indigo-50 hover:to-blue-50 hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] ${
                            index > currentMonth || month.count <= 0 
                                ? 'opacity-50 cursor-not-allowed border-gray-200 bg-gradient-to-br from-gray-50 to-gray-100' 
                                : 'cursor-pointer border-indigo-200 hover:border-indigo-400 shadow-md'
                        }`}
                        onClick={() => downloadLic(index, month.count)}
                    >
                        {/* Background Pattern */}
                        <div className="absolute inset-0 opacity-5">
                            <div className="absolute -top-2 -right-2 w-12 h-12 bg-indigo-500 rounded-full"></div>
                            <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-blue-500 rounded-full"></div>
                        </div>
                        
                        <div className="flex-1 relative z-10">
                            <h1 className={`text-lg sm:text-xl font-bold mb-1 ${
                                index > currentMonth || month.count <= 0 ? 'text-gray-500' : 'text-gray-800'
                            }`}>
                                {month.key}
                            </h1>
                            <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold ${
                                month.count > 0 && index <= currentMonth
                                    ? 'bg-gradient-to-r from-indigo-100 to-blue-100 text-indigo-700'
                                    : 'bg-gray-200 text-gray-600'
                            }`}>
                                {month.count} licenses
                            </div>
                            
                            {index > currentMonth && (
                                <div className="mt-1 text-xs text-gray-500 font-medium">
                                    Available next month
                                </div>
                            )}
                        </div>
                        
                        <div className="flex-shrink-0 ml-3 relative z-10">
                            <div className={`p-2 sm:p-3 rounded-full transition-all duration-300 ${
                                index <= currentMonth && month.count > 0
                                    ? 'bg-gradient-to-r from-indigo-500 to-blue-600 group-hover:from-indigo-600 group-hover:to-blue-700 shadow-lg group-hover:shadow-xl'
                                    : 'bg-gray-300'
                            }`}>
                                <DownloadLic
                                    className={`w-5 h-5 sm:w-6 sm:h-6 transition-all duration-300 ${
                                        index <= currentMonth && month.count > 0
                                            ? 'text-white group-hover:scale-110'
                                            : 'text-gray-500'
                                    }`}
                                />
                            </div>
                        </div>
                        
                        {/* Hover Effect Overlay */}
                        {index <= currentMonth && month.count > 0 && (
                            <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/0 to-blue-600/0 group-hover:from-indigo-600/5 group-hover:to-blue-600/5 transition-all duration-300 rounded-xl"></div>
                        )}
                    </div>
                    
                ))}
            </div>
        </div>
    );
}